:host {
  display: block;
  font-family: var(--sc-font-sans);
  --sc-product-line-item-line-gap: 6px;
}

.item {
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  gap: var(--sc-spacing-large);
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  border-bottom: none;
  container-type: inline-size;

  &__text-container {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    display: flex;
    flex-direction: column;
    gap: var(--sc-product-line-item-line-gap);
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    border-bottom: none;
  }

  &__row {
    display: flex;
    gap: 18px;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;

    &.stick-bottom {
      margin-top: auto;
    }
  }

  &__scratch-price {
    text-decoration: line-through;
    font-size: var(--sc-font-size-small);
    line-height: 1;
    color: var(--sc-input-help-text-color);
    white-space: nowrap;
  }

  &__remove-container {
    display: flex;
    gap: 6px;
    align-items: center;
    line-height: 1;
    cursor: pointer;
    color: var(--sc-input-help-text-color);
    font-size: var(--sc-input-help-text-font-size-medium);
  }

  &__add-review {
    sc-button {
      --sc-input-border-radius-small: var(--sc-input-border-radius-medium);
    }
  }

  &--has-review {
    border-bottom: solid 1px var(--sc-input-border-color, var(--sc-input-border));
    padding-top: var(--sc-spacing-small);
    padding-bottom: var(--sc-spacing-large);

    :host(:first-of-type) & {
      padding-top: 0;
    }
  }
}

.item__text {
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 0%;
}

.item__text-details {
  display: grid;
  gap: var(--sc-product-line-item-line-gap);
}

.item__title {
  box-sizing: border-box;
  min-width: 0px;
  margin: 0;
  color: var(--sc-line-item-title-color, var(--sc-input-label-color));
  font-size: var(--sc-font-size-medium);
  font-weight: var(--sc-font-weight-semibold);
  line-height: 1;
  cursor: pointer;
  display: -webkit-box;
  display: -moz-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-box-lines: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item__suffix {
  flex: 1;
  box-sizing: border-box;
  margin: 0px;
  min-width: 0px;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: space-between;
  align-items: flex-end;
  min-width: 100px;
  margin-left: auto;
  align-self: center;
}

.product-line-item__removable .item__suffix {
  align-self: flex-start;
}
.product-line-item__editable .item__suffix {
  align-self: flex-start;
}

.product-line-item__purchasable-status {
  font-size: var(--sc-font-size-x-small);
  color: var(--sc-input-error-text-color);
}

.item__price {
  text-align: right;
  max-width: 100%;
  display: grid;
  gap: var(--sc-product-line-item-line-gap);
}

.item__description {
  color: var(--sc-price-label-color, var(--sc-input-help-text-color));
  font-size: var(--sc-price-label-font-size, var(--sc-input-help-text-font-size-medium));
  line-height: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: var(--sc-product-line-item-line-gap);
  text-wrap: pretty;

  &:last-child {
    align-items: flex-end;
    text-align: right;
  }
}

.item__image-placeholder {
  width: var(--sc-product-line-item-image-size, 65px);
  height: var(--sc-product-line-item-image-size, 65px);
  background-color: var(--sc-input-border-color, var(--sc-input-border));
  border-radius: 4px;
  flex: 0 0 var(--sc-product-line-item-image-size, 65px);
}

.item__image,
.attachment-thumbnail {
  width: var(--sc-product-line-item-image-size, 65px);
  height: var(--sc-product-line-item-image-size, 65px);
  object-fit: cover;
  border-radius: 4px;
  border: solid 1px var(--sc-input-border-color, var(--sc-input-border));
  display: block;
  box-shadow: var(--sc-input-box-shadow);
  align-self: flex-start;
}

@container (max-width: 380px) {
  .item__image,
  .item__image-placeholder {
    display: var(--sc-product-line-item-mobile-image-display, none);
  }
}

.product__description {
  display: flex;
  gap: 0.5em;
  align-items: center;
}

.price {
  font-size: var(--sc-font-size-medium);
  font-weight: var(--sc-font-weight-semibold);
  color: var(--sc-input-label-color);
  line-height: 1;
  white-space: nowrap;
  display: flex;
  gap: 4px;
  align-items: baseline;
}

.price__description {
  font-size: var(--sc-font-size-small);
  line-height: 1;
  color: var(--sc-input-help-text-color);
  text-align: right;
  white-space: nowrap;
}

.item--is-rtl {
  &.price {
    text-align: right;
  }
  .item__price {
    text-align: left;
  }
}

.base {
  display: grid;
  gap: var(--sc-spacing-x-small);
}

.fee__description {
  color: var(--sc-input-help-text-color);
}

sc-quantity-select::part(base) {
  box-shadow: none;
  background-color: transparent;
}

sc-quantity-select::part(base):not(:focus-within) {
  border-color: transparent;
}

sc-quantity-select::part(input),
sc-quantity-select::part(plus),
sc-quantity-select::part(minus) {
  background-color: transparent;
}
